import { Component, OnInit } from '@angular/core';
import { IdmUtilities } from '@platform-idm/sdk-javascript';
import { PlatformIdmService } from '@platform-idm/sdk-angular';

@Component({
    selector: 're-slologout',
    templateUrl: './slologout.component.html',
    styleUrls: ['./slologout.component.scss'],
    standalone: false
})
export class SloLogoutComponent implements OnInit {

  constructor(
    private authService: PlatformIdmService
  ) { }

  ngOnInit() {
    (this.authService.authentication as any)?.stopTimers();

    const utilities = new IdmUtilities();

	    if (utilities.getQueryVariable('sloRedirect') === 'true') {
	      // Historically this key was used only for DUO, but AppComponent.logout
	      // now stores a generic federated IdP logout URL (DUO or other
	      // providers) under the same key for backward compatibility.
	      const federatedLogoutUrl = localStorage.getItem('duoLogoutUrl');
	      if (federatedLogoutUrl) {
	        localStorage.removeItem('duoLogoutUrl');
	        window.location.href = federatedLogoutUrl;
	        return;
	      } else {
	        // Fallback: no federated logout URL available. Redirect the user to
	        // login instead of leaving them stuck on the /slologout page.
	        //
	        // This does not change SLO behavior when properly configured
	        // (a logout URL is present in localStorage); it only handles cases
	        // where SLO is disabled or no URL was stored.
	        window.location.href = '/login';
	        return;
	      }
	    }
  }

}
